export const load = (zwibbler, document) => {
  let bgId, url;
  if (document[2].type === "ImageNode" && document[2].locked === true) {
    bgId = document[2].id;
    url = document[2].url;
  } else if (
    document[0].type === "document" &&
    document[3].type === "ImageNode" &&
    document[3].locked === true
  ) {
    bgId = document[3].id;
    url = document[3].url;
  }
  // this is the only required line in this func, All others are bug work-a-rounds
  zwibbler.load("zwibbler3." + JSON.stringify(document));
  if (bgId) {
    //  zwibbler.deleteNode(bgId);
    //zwibbler.setNodeProperty(bgId, "locked", true);
    // zwibbler.setConfig("backgroundImage", url);
  }
};

export const save = (zwibbler, options) => {
  let timeOut = 50;

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      let { format, rect } = options;
      if (!format) {
        format = "png";
      }
      if (format === "doc") {
        format = "zwibbler3";
      }

      const dataURL = rect.x
        ? zwibbler.save(format, rect)
        : zwibbler.save(format);
      let z = rect.x
        ? zwibbler.save("zwibbler3", rect)
        : zwibbler.save("zwibbler3");
      z = z.substring(10);

      let document = {
        zwibbler: JSON.parse(z),
        godraw: {
          config: {
            pageView: zwibbler.getConfig("pageView"),
            background: zwibbler.getConfig("background")
          }
        }
      };

      const result = {
        type: format,
        dataURL,
        document: JSON.stringify(document)
      };
      resolve(result);
    }, timeOut);
  });
};

export const undo = zwibbler => {
  return zwibbler.undo();
};

export const redo = zwibbler => {
  return zwibbler.redo();
};

export const setDocumentSize = (zwibbler, { width, height }) => {
  if (width <= 0) width = null;
  if (height <= 0) height = null;

  return zwibbler.setDocumentSize(width, height);
};
export const getDocumentSize = zwibbler => {
  return zwibbler.getDocumentSize();
};

export const getScale = zwibbler => {
  return zwibbler.getScale();
};

export const getCurrentTool = zwibbler => {
  return zwibbler.getCurrentTool();
};

export const zoom = (zwibbler, inOrOut) => {
  const scaleSize = 0.25;
  let scaleFactor = inOrOut === "in" ? 1 + scaleSize : 1 - scaleSize;
  console.log(scaleFactor);
  console.log(inOrOut);
  let scale = zwibbler.getCanvasScale() * scaleFactor;

  zwibbler.setZoom(scale);
};

export const getDocumentProperties = zwibbler => {
  return {
    size: zwibbler.getDocumentSize(),
    drawingRect: zwibbler.getDrawingRectangle(),
    background: zwibbler.getConfig("background"),
    backgroundImage: zwibbler.getConfig("backgroundImage"),
    pageView: zwibbler.getConfig("pageView")
  };
};



// WEBPACK FOOTER //
// ./src/components/Zwibbler/ExternalApi/handlers/Document.js